export default "__VITE_ASSET__pjj3U66___"